<div class="landing-banner">
  <img
    class="banner-flag"
    alt=""
    src="../../../assets/images/landing-banner/p_flag.png"
  />
  <img
    class="banner-star-1"
    alt=""
    src="../../../assets/images/landing-banner/p_star_1.png"
  />
  <img
    class="banner-star-2"
    alt=""
    src="../../../assets/images/landing-banner/p_star_2.png"
  />
  <img
    class="banner-word-1"
    alt="Camp is Just a Click Away"
    src="../../../assets/images/landing-banner/p_word_1.png"
  />
  <img
    class="banner-word-2"
    alt="Ready, Set, Play!"
    src="../../../assets/images/landing-banner/p_word_2.png"
  />
</div>
<app-landing-upcoming
  [bookingList]="this.bookingService.landingBookingList"
  role="region"
></app-landing-upcoming>
<div class="row no-gutters justify-content-center dog-location-container">
  <div class="col-12 col-md order-2 order-md-1 dog-col">
    <app-landing-dog
      [petTileList]="petTileList"
      [showReleaseError]="showTermPolicyFormsError"
      role="region"
    ></app-landing-dog>
  </div>
  <div class="col-12 col-md order-1 order-md-2 location-col">
    <app-landing-location
      [locationTileList]="locationTileList"
      role="region"
    ></app-landing-location>
  </div>
</div>
<app-landing-marketing
  #marketing
  role="region"
  [marketingTiles]="marketingTileList$"
>

</app-landing-marketing>
